import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_103_inspection: any[] = [
            {
                "componentType": "screenGroup",
                "fabAction": {
                    "type": "add",
                    "screenId": "107"
                },
                "title": "Inspection",
                "style": {
                    "backgroundColor": "#F9FAFB"
                },
                "childComponents": [
                    {
                        "componentType": "group",
                        "style": {
                            "backgroundColor": "#ffffff",
                            "direction": "column",
                            "borderRadius": 12
                        },
                        "childComponents": [
                            {
                                "componentType": "summeryList",
                                "titleValue": "vin_no",
                                "Name": "vehiclein_summary",
                                "style": {
                                    "maxHeight": "calc(100vh - 350px)"
                                },
                                "Form": {
                                    "Name": "vehiclein_summary",
                                    "TableName": "service_details",
                                    "Plugins": [
                                        {
                                            "type": "api"
                                        }
                                    ],
                                    "View": "view_vehiclein_summary",
                                    "Filter": "view_vehiclein_summary.soft_delete=0",
                                    "DefaultSort": "view_vehiclein_summary.created_at desc",
                                    "Fields": [
                                        {
                                            "IncludeLabel": true,
                                            "Label": "ID#",
                                            "BindValue": "id",
                                            "Json_Attribute": "id",
                                            "componentType": "textField",
                                            "showInSummary": false
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "Jobcard ID",
                                            "BindValue": "jobcard_id",
                                            "Json_Attribute": "jobcard_id",
                                            "componentType": "textField",
                                            "showInSummary": false
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "VIN No.",
                                            "BindValue": "vin_number",
                                            "Json_Attribute": "vin_no",
                                            "componentType": "textField",
                                            "showInSummary": true
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "VIN date",
                                            "IsMandatory": false,
                                            "BindValue": "vin_date",
                                            "Json_Attribute": "vin_date",
                                            "componentType": "dateField",
                                            "showInSummary": true
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "Customer name",
                                            "IsMandatory": false,
                                            "BindValue": "customername",
                                            "Json_Attribute": "customername",
                                            "componentType": "textField",
                                            "showInSummary": true
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "Vehicle No.",
                                            "IsMandatory": false,
                                            "BindValue": "platenumber",
                                            "Json_Attribute": "platenumber",
                                            "componentType": "textField",
                                            "showInSummary": true,
                                            "StickyColumn": "left",
                                            "StickyWidth": "200px"
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "Jobcard No.",
                                            "IsMandatory": false,
                                            "BindValue": "jobcard_no",
                                            "Json_Attribute": "jobcard_no",
                                            "componentType": "textField",
                                            "showInSummary": true,
                                            "StickyColumn": "left",
                                            "StickyWidth": "200px"
                                        },
                                        {
                                            "IncludeLabel": true,
                                            "Label": "Parts issue",
                                            "IsMandatory": false,
                                            "BindValue": "issue_status",
                                            "Json_Attribute": "issue_status",
                                            "componentType": "textField",
                                            "showInSummary": true,
                                            "StickyColumn": "left",
                                            "StickyWidth": "200px"
                                        }
                                    ]
                                },
                                "workflow": [
                                    {
                                        "Name": "Inspected",
                                        "Label": "Inspected",
                                        "States": [
                                            "Inspected"
                                        ],
                                        "Action": "Inspect",
                                        "Screen": "modulev1/vehiclein_add",
                                        "screenId": "107",
                                        "Action_ref_column": "inspection_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/vehicle_in/<id>"
                                                },
                                                "ScreenId": "107"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "Estimated",
                                        "Label": "Estimated",
                                        "Action": "Estimate",
                                        "EnableOn": [
                                            "Inspected",
                                            "Rejected"
                                        ],
                                        "States": [
                                            "Estimated"
                                        ],
                                        "Screen": "modulev1/estimation_add",
                                        "ActionArgs": {
                                            "parentid": "<id>"
                                        },
                                        "Action_ref_column": "estimate_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/estimation_add/<id>"
                                                },
                                                "ScreenId": "116"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "Approved",
                                        "Label": "Approved",
                                        "Action": "Approve",
                                        "EnableOn": [
                                            "Estimated"
                                        ],
                                        "States": [
                                            "Approved",
                                            "Rejected",
                                            "Put on hold"
                                        ],
                                        "Screen": "modulev1/estimateapproval",
                                        "Action_ref_column": "approved_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/estimateapproval/<id>"
                                                },
                                                "ScreenId": "150"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "jobCard",
                                        "Label": "Job card",
                                        "Action": "Job card",
                                        "EnableOn": [
                                            "Approved",
                                            "QC Rejected"
                                        ],
                                        "States": [
                                            "Job card"
                                        ],
                                        "Screen": "modulev1/jobcard_add",
                                        "ActionArgs": {
                                            "parentid": "<approved_id>"
                                        },
                                        "Action_ref_column": "jobcard_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate_Load",
                                                    "Navigate": "module/jobcard_add/<id>"
                                                },
                                                "ScreenId": "156"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "QC Approved",
                                        "Label": "QC Approved",
                                        "EnableOn": [
                                            "Job card"
                                        ],
                                        "Action": "QC Approve",
                                        "States": [
                                            "QC Approved",
                                            "QC Rejected"
                                        ],
                                        "Screen": "modulev1/qc_approve",
                                        "Action_ref_column": "qc_approved_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/QualityCheckApproval/<id>"
                                                },
                                                "ScreenId": "157"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "Invoiced",
                                        "Label": "Invoiced",
                                        "EnableOn": [
                                            "QC Approved"
                                        ],
                                        "Action": "Create invoice",
                                        "States": [
                                            "Invoiced"
                                        ],
                                        "Screen": "modulev1/invoice_add",
                                        "ActionArgs": {
                                            "parentid": "<id>"
                                        },
                                        "Action_ref_column": "invoice_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/invoice_add/<id>"
                                                },
                                                "ScreenId": "158"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "Gate Pass Issued",
                                        "Label": "Gate Pass Issued",
                                        "EnableOn": [
                                            "Invoiced"
                                        ],
                                        "Action": "Create Gate Pass",
                                        "States": [
                                            "Gate Pass Issued"
                                        ],
                                        "Screen": "modulev1/gate_pass_issue",
                                        "ActionArgs": {
                                            "parentid": "<id>"
                                        },
                                        "Action_ref_column": "gate_pass_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/gate_pass_issue/<id>"
                                                },
                                                "ScreenId": "176"
                                            }
                                        ]
                                    },
                                    {
                                        "Name": "Close",
                                        "Label": "Close",
                                        "EnableOn": [
                                            "Gate Pass Issued"
                                        ],
                                        "Action": "Close",
                                        "States": [
                                            "Closed"
                                        ],
                                        "Screen": "modulev1/close_jobcard",
                                        "Action_ref_column": "closed_id",
                                        "WorkFlowActions": [
                                            {
                                                "Action": {
                                                    "Action": "Navigate",
                                                    "Navigate": "module/close_jobcard/<id>"
                                                },
                                                "ScreenId": "39"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
